import { MenuItem, Select, Typography } from '@material-ui/core'
import { ArrowForward } from '@material-ui/icons'
import { ConditionBadge } from 'components/facets/ConditionBadge'
import {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { CONDITIONS_MAP_WITH_LABELS } from 'shared'

export interface EditConditionCellInterface {
  locationName: any
  oldValue: any
  setNewCondition: any
  disabled: boolean
}

export interface EditConditionCellRef {
  resetValue: () => void
}

const EditConditionCell: ForwardRefRenderFunction<
  EditConditionCellRef,
  EditConditionCellInterface
> = ({ locationName, oldValue, setNewCondition, disabled }, ref) => {
  const [hasEditedValue, setHasEditedValue] = useState(false)
  const [newEditedValue, setNewEditedValue] = useState(oldValue)

  useImperativeHandle(ref, () => ({
    resetValue() {
      setNewEditedValue(oldValue)
      setNewCondition(oldValue)
    },
  }))

  const handleChanges = (event: any) => {
    setNewCondition(event.target.value)
    setNewEditedValue(event.target.value)
  }

  useEffect(() => {
    if (oldValue === newEditedValue) setHasEditedValue(false)
    else setHasEditedValue(true)
  }, [oldValue, newEditedValue])

  return hasEditedValue ? (
    <div className="d-flex flex-row justify-content-center align-items-center">
      <Typography>{oldValue}</Typography>
      <ArrowForward className="mx-1" />

      <Select
        className="locations-panel"
        data-testid={`condition-${locationName}`}
        value={newEditedValue}
        onChange={(e) => {
          handleChanges(e)
        }}
      >
        {CONDITIONS_MAP_WITH_LABELS.map((c) => (
          <MenuItem key={`${locationName}-${c}`} value={c.code}>
            <ConditionBadge condition={c.name} />
          </MenuItem>
        ))}
      </Select>
    </div>
  ) : (
    <Select
      className="locations-panel"
      data-testid={`condition-${locationName}`}
      value={newEditedValue}
      onChange={(e) => {
        handleChanges(e)
      }}
      disabled={disabled}
    >
      {CONDITIONS_MAP_WITH_LABELS.map((c) => (
        <MenuItem key={`${locationName}-${c}`} value={c.code}>
          {c.name}
        </MenuItem>
      ))}
    </Select>
  )
}

export default forwardRef(EditConditionCell)
